import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-blue-900 to-blue-800 text-white py-2">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm">
            <div className="flex flex-wrap items-center gap-4 mb-2 md:mb-0">
              <a href={`tel:${process.env.REACT_APP_COMPANY_PHONE}`} className="flex items-center gap-2 hover:text-blue-200 transition">
                <Phone className="w-4 h-4" />
                <span>{process.env.REACT_APP_COMPANY_PHONE}</span>
              </a>
              <a href={`mailto:${process.env.REACT_APP_COMPANY_EMAIL}`} className="flex items-center gap-2 hover:text-blue-200 transition">
                <Mail className="w-4 h-4" />
                <span>{process.env.REACT_APP_COMPANY_EMAIL}</span>
              </a>
            </div>
            <div className="flex items-center gap-4">
              <div className="hidden md:flex items-center gap-2 text-blue-200">
                <MapPin className="w-4 h-4" />
                <span>{process.env.REACT_APP_COMPANY_ADDRESS || 'R. Monsenhor Miguel de Oliveira 1272, 3880-796 Ovar'}</span>
              </div>

              {/* Social Media Icons */}
              <div className="flex items-center gap-3">
                <a
                  href="https://www.facebook.com/share/1KJMW3u1JB/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-200 hover:text-white transition"
                  aria-label="Facebook"
                >
                  <Facebook className="w-4 h-4" />
                </a>
                <a
                  href="https://www.instagram.com/diamond_cars_rg?igsh=MWR6MW9ydnQ2OWxxdQ=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-200 hover:text-white transition"
                  aria-label="Instagram"
                >
                  <Instagram className="w-4 h-4" />
                </a>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/">
              <img src="/logo-black.svg" alt={process.env.REACT_APP_COMPANY_NAME || 'Diamond Cars'} className="h-14 w-auto object-contain" />
            </Link>

            {/* Desktop Menu */}
            <nav className="hidden lg:flex items-center space-x-8">
              <Link
                to="/"
                className={`text-base font-semibold transition-colors ${
                  isActive('/')
                    ? 'text-blue-600 border-b-2 border-blue-600'
                    : 'text-gray-700 hover:text-blue-600'
                } pb-1`}
              >
                Home
              </Link>
              <Link
                to="/viaturas"
                className={`text-base font-semibold transition-colors ${
                  isActive('/viaturas')
                    ? 'text-blue-600 border-b-2 border-blue-600'
                    : 'text-gray-700 hover:text-blue-600'
                } pb-1`}
              >
                Viaturas
              </Link>
              <Link
                to="/sobre"
                className={`text-base font-semibold transition-colors ${
                  isActive('/sobre')
                    ? 'text-blue-600 border-b-2 border-blue-600'
                    : 'text-gray-700 hover:text-blue-600'
                } pb-1`}
              >
                Sobre Nós
              </Link>
              <Link
                to="/contacto"
                className="bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition font-semibold shadow-md hover:shadow-lg"
              >
                Contactos
              </Link>
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 rounded-md hover:bg-gray-100 transition"
            >
              {isMenuOpen ? (
                <X className="w-6 h-6 text-gray-700" />
              ) : (
                <Menu className="w-6 h-6 text-gray-700" />
              )}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="lg:hidden py-4 border-t">
              <nav className="flex flex-col space-y-3">
                <Link
                  to="/"
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-4 py-3 rounded-md font-semibold transition ${
                    isActive('/')
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  Home
                </Link>
                <Link
                  to="/viaturas"
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-4 py-3 rounded-md font-semibold transition ${
                    isActive('/viaturas')
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  Viaturas
                </Link>
                <Link
                  to="/sobre"
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-4 py-3 rounded-md font-semibold transition ${
                    isActive('/sobre')
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  Sobre Nós
                </Link>
                <Link
                  to="/contacto"
                  onClick={() => setIsMenuOpen(false)}
                  className="mx-4 bg-blue-600 text-white px-4 py-3 rounded-md hover:bg-blue-700 transition font-semibold text-center"
                >
                  Contactos
                </Link>
              </nav>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
